module.exports = __webpack_public_path__ + "static/media/trips_empty.a26515f4.png";